// export default class Transform {
//   constructor({ listProduct, detailProduct, transactionList, historyList }) {
//     this.listProduct = listProduct;
//     this.detailProduct = detailProduct;
//     this.transactionList = transactionList;
//     this.historyList = historyList;
//   }
//   get productsDetail() {
//     return this.detailProduct;
//   }
// }
class Transform {
  constructor({ response, data }) {
    this.response = response;
    this.data = data;
  }

  get productList() {
    const array = [];
    this.response.map(item => {
      const data = {
        admin_fee: item.admin_fee,
        benefits: item.benefits,
        category: item.category,
        contents: item.contents,
        currency_code: item.currency_code,
        detail: item.detail,
        entity: item.entity,
        hardcopy_admin_fee: item.hardcopy_admin_fee,
        insurance: item.insurance,
        insurance_code: item.insurance_code,
        insurer_name: item.insurer_name,
        is_active: item.is_active,
        logo: item.logo,
        name: item.name,
        premium: item.premium,
        premium_period: item.premium_period,
        premium_type: item.premium_type,
        product_category: item.product_category,
        product_code: item.product_code,
        summary: item.summary,
        terms: item.terms
      };
      array.push(data);
    });
    return array;
  }

  get policyList() {
    const array = [];
    this.response.map(item => {
      const data = {
        coveredUsers: item.coveredUsers,
        createdAt: item.createdAt,
        customer: item.customer,
        health: item.health,
        insurance: item.insurance,
        invoice: item.invoice,
        number: item.number,
        policyHolder: item.policyHolder,
        product: item.product,
        status: item.status,
        transaction: item.transaction,
        updatedAt: item.updatedAt
      };
      array.push(data);
    });
    return array;
  }

  get policyDetail() {
    const item = this.response;
    let object = {
      coveredUsers: [],
      createdAt: '',
      customer: {},
      documents: [],
      health: {},
      histories: [],
      insurance: {},
      invoice: {},
      number: '',
      policyHolder: {},
      product: {},
      status: '',
      transaction: {},
      type: '',
      updatedAt: ''
    };
    if (item) {
      object = {
        coveredUsers: item.coveredUsers,
        createdAt: item.createdAt,
        customer: item.customer,
        documents: item.documents,
        health: item.health,
        histories: item.histories,
        insurance: item.insurance,
        invoice: item.invoice,
        number: item.number,
        policyHolder: item.policyHolder,
        product: item.product,
        status: item.status,
        transaction: item.transaction,
        type: item.type
      };
      return object;
    }
    return object;
  }

  get productDetail() {
    const item = this.response;
    let Obj = {
      admin_fee: '',
      benefits: '',
      category: {
        code: '',
        description: '',
        name: '',
        type: ''
      },
      contents: '',
      currency_code: '',
      detail: {
        claim: {
          flow: [],
          support: {
            available: '',
            call: '',
            email: ''
          }
        },
        excerpt: [],
        label: [],
        position: '',
        product: {
          benefits: {},
          coverages: [],
          description: '',
          generalInsuranceName: '',
          name: '',
          planCode: '',
          spesific: [],
          url: {
            brochure: '',
            claimDocument: '',
            claimForm: '',
            tnc: '',
            hospital: ''
          }
        },
        requiredQuestion: [],
        terms: []
      },
      entity: '',
      free_look_period: '',
      hardcopy_admin_fee: '',
      insurance: {
        alias: '',
        code: '',
        is_active: '',
        logo: '',
        name: ''
      },
      insurance_code: '',
      insurance_detail: '',
      insurer_name: '',
      is_active: '',
      isChecked: '',
      logo: '',
      name: '',
      period: {
        periodEnd: '',
        periodStart: ''
      },
      premium: 0,
      premium_period: '',
      premium_type: '',
      product_category: '',
      product_code: '',
      questions: [],
      summary: '',
      terms: ''
    };
    if (item) {
      Obj = {
        admin_fee: item.admin_fee,
        benefits: item.benefits,
        category: {
          code: item.category.code,
          description: item.category.description,
          name: item.category.name,
          type: item.category.type
        },
        contents: item.contents,
        currency_code: item.currency_code,
        detail: {
          claim: {
            flow: item.detail.claim.flow,
            support: {
              available: item.detail.claim.support.available,
              call: item.detail.claim.support.call,
              email: item.detail.claim.support.email
            }
          },
          excerpt: item.detail.excerpt,
          label: item.detail.label,
          position: item.detail.position,
          product: {
            benefits: item.detail.product.benefits,
            coverages: item.detail.product.coverages,
            description: item.detail.product.description,
            generalInsuranceName: item.detail.product.generalInsuranceName,
            name: item.detail.product.name,
            planCode: item.detail.product.planCode,
            spesific: item.detail.product.spesific,
            url: {
              brochure: item.detail.product.url.brochure,
              claimDocument: item.detail.product.url.claimDeath,
              claimForm: item.detail.product.url.claimForm,
              tnc: item.detail.product.url.tnc,
              hospital: item.detail.product.url.hospital
            }
          },
          requiredQuestion: item.detail.requiredQuestion,
          terms: item.detail.terms
        },
        entity: item.entity,
        free_look_period: item.free_look_period,
        hardcopy_admin_fee: item.hardcopy_admin_fee,
        insurance: {
          alias: item.insurance.alias,
          code: item.insurance.code,
          is_active: item.insurance.is_active,
          logo: item.insurance.logo,
          name: item.insurance.name
        },
        insurance_code: item.insurance_code,
        insurance_detail: item.insurance_detail,
        insurer_name: item.insurer_name,
        is_active: item.is_active,
        isChecked: item.isChecked,
        logo: item.logo,
        name: item.name,
        period: {
          periodEnd: item.period.periodEnd,
          periodStart: item.period.periodStart
        },
        premium: item.premium,
        premium_period: item.premium_period,
        premium_type: item.premium_type,
        product_category: item.product_category,
        product_code: item.product_code,
        questions: item.questions,
        summary: item.summary,
        terms: item.terms
      };
      return Obj;
    }
    return Obj;
  }

  get prequoteData() {
    const item = this.data;
    let Obj = {
      category: '',
      covereds: [],
      products: []
    };
    if (item) {
      Obj = {
        category: item.category,
        covereds: item.covereds,
        products: item.products
      };
      return Obj;
    }
    return Obj;
  }
}

export const mapResponse = ({ type, response }) => {
  const transformResponse = new Transform({ response });
  return transformResponse[type];
};

export const mapPayload = ({ type, data }) => {
  const transformPayload = new Transform({ data });
  return transformPayload[type];
};
